import type { supabase } from '@/integrations/supabase/client';

// Left embedding keeps conversations with no messages in the result.
export function coachThreadSummaryQuery(client: typeof supabase) {
  return client.from('client_threads')
    .select('*, latest_messages:client_messages!client_messages_thread_id_fkey(message_text, sender_role, created_at)')
    .order('created_at', { referencedTable: 'latest_messages', ascending: false })
    .limit(1, { referencedTable: 'latest_messages' })
    .order('updated_at', { ascending: false });
}

export function clientThreadSummaryQuery(client: typeof supabase, userId: string) {
  return client.from('client_threads')
    .select('*, latest_messages:client_messages!client_messages_thread_id_fkey(sender_role, created_at)')
    .eq('latest_messages.sender_role', 'coach')
    .order('created_at', { referencedTable: 'latest_messages', ascending: false })
    .limit(1, { referencedTable: 'latest_messages' })
    .eq('client_id', userId)
    .order('updated_at', { ascending: false });
}